import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Construct} from 'classes/construct';
import {ConstructListRepository} from './../repositories/construct-list.repository';

@Injectable()
export class ConstructListService {

  constructor(private constructListRepository: ConstructListRepository) { }

  public getUndistributedConstructs(full: boolean): Observable<Array<Construct>> {
    return this.constructListRepository.getUndistributedConstructs(full);
  }

  public getConstructFull(construct: Construct): Observable<Construct> {
    return this.constructListRepository.getConstructById(construct._id)
      .map((constructFull) => {
        // filter questions
        const questionIDStrings = new Set(construct.keptQuestionIds);

        constructFull.questions = constructFull.questions.filter((question) => {
          return questionIDStrings.has(question._id.toString());
        });
        return constructFull;
      })
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-details/construct-list/services/construct-list.service.ts